
import { Box, Paper } from '@mui/material';
import { Ico_ExclamationMark, Ico_Correct } from '@sagecentral/core-ui';
import { useTaskContext } from 'hooks/tasks';

const SuccessorTaskMissingResourceBox = () => {
    const taskContext = useTaskContext();
    const { task } = taskContext;

    if (task != null && !task?.successorTaskMissingResource)
        return null;

    return (
        <Box sx={{ pt: '27px' }}>
            <Paper elevation={3} >
                <Box sx={{ padding: '16px' }}>
                    <Box sx={{ paddingBottom: '16px' }}>{task?.successorTaskMissingResource ? <Ico_ExclamationMark sx={{ width: '40px', height: '40px', fill: '#EB0000' }} /> : <Ico_Correct sx={{ width: '40px', height: '40px', stroke: '#008929' }} />}</Box>
                    <Box sx={{ fontSize: '14px', display: 'grid', gap: '12px' }}>
                        {task &&
                            <Box>
                                The following task in the workflow hasn’t been assigned a resource. You will not be able to complete your task until this has been done. Please see the Task Dependencies tab and contact your manager for more details.
                            </Box>
                        }
                    </Box>
                </Box>
            </Paper>
        </Box>
    )
}

export default SuccessorTaskMissingResourceBox;